// src/redux/slices/companyAdminSlice.js
import { createSlice } from '@reduxjs/toolkit';

const companyAdminSlice = createSlice({
  name: 'companyAdmin',
  initialState: {
    admins: [],
  },
  reducers: {
    setCompanyAdmins: (state, action) => {
      state.admins = action.payload;
    },
    clearCompanyAdmins: (state) => {
      state.admins = [];
    },
  },
});

export const { setCompanyAdmins, clearCompanyAdmins } = companyAdminSlice.actions;
export default companyAdminSlice.reducer;

